import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Chip,
  Tooltip,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import type { PendingInvitation } from '../../../../types/team';

interface PendingInvitationListProps {
  invitations: PendingInvitation[];
  onCancel: (invitationId: number) => void;
}

export function PendingInvitationList({ invitations, onCancel }: PendingInvitationListProps) {
  if (invitations.length === 0) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 6 },
          textAlign: 'center',
          backgroundColor: 'background.default',
          border: '1px dashed',
          borderColor: 'divider',
        }}
      >
        <MailOutlineIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
        <Typography variant="h6" gutterBottom>
          Немає запрошених
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Тут з'являться email-адреси, що очікують підтвердження запрошення
        </Typography>
      </Paper>
    );
  }

  return (
    <List disablePadding>
      {invitations.map((invitation) => (
        <ListItem key={invitation.id} divider>
          <ListItemText
            primary={invitation.email}
            slotProps={{ primary: { noWrap: true } }}
            sx={{ minWidth: 0, mr: 1 }}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
            <Chip
              label={invitation.expired ? 'Термін дії минув' : 'Очікує підтвердження'}
              size="small"
              color={invitation.expired ? 'default' : 'warning'}
            />
            <Tooltip title="Скасувати запрошення">
              <IconButton size="small" color="error" onClick={() => onCancel(invitation.id)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </ListItem>
      ))}
    </List>
  );
}
